interface Props {
  size?: number;
  color?: string;
}

const EyeIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 24 24`}
    >
      <path
        d="M15.1645 12C15.1645 13.6569 13.8214 15 12.1645 15C10.5077 15 9.16455 13.6569 9.16455 12C9.16455 10.3431 10.5077 9 12.1645 9C13.8214 9 15.1645 10.3431 15.1645 12Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1653 5C7.68761 5 3.89733 7.94288 2.62305 12C3.89731 16.0571 7.68761 19 12.1653 19C16.6429 19 20.4332 16.0571 21.7075 12C20.4332 7.94291 16.6429 5 12.1653 5Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EyeIcon;
